<template>
  <nav class="navbar">
    <div class="nav-container">
      <div class="logo">
        Govori Brani~evo
      </div>
      
      <button class="menu-toggle" @click="toggleMenu">
        <span :class="{ open: isOpen }"></span>
        <span :class="{ open: isOpen }"></span>
        <span :class="{ open: isOpen }"></span>
      </button>

      <ul :class="['nav-links', { open: isOpen }]">
        <li>
            <a href="#">
              <img src="@/assets/ljiljan.png"  class="menu-image" />
               Po~etna
            </a>
        </li>
        <li>
          <a href="#">
            <img src="@/assets/ljiljan.png"  class="menu-image" />
            Tekstovi
          </a>
        </li>
        <li>
          <a href="#">
            <img src="@/assets/ljiljan.png"  class="menu-image" />
          Istorijske slike
          </a>
        </li>
        <li>
          <a href="#">
            <img src="@/assets/ljiljan.png" class="menu-image" />
           Grbovi
          </a>
        </li>
      </ul>
    </div>
  </nav>
</template>


<script setup>
import { ref } from 'vue'

const isOpen = ref(false)

function toggleMenu() {
  isOpen.value = !isOpen.value
}
</script>

<style scoped>
/* Base Navbar Styles */
.navbar {
  background-color: #ffffff;
  color: rgb(8, 8, 8);
  padding: 0.75rem 1rem;
  position: relative;
}

.nav-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

/* Logo */
.logo {
  font-size: 1.5rem;
  font-weight: bold;
}

/* SVG Icon Styling */
.icon {
  width: 18px;
  height: 18px;
  margin-right: 8px;
  stroke-width: 2;
}

/* Align icons and text horizontally */
.nav-links li a {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}


/* Navigation Links */
.nav-links {
  list-style: none;
  display: flex;
  gap: 1rem;
}

.nav-links li a {
  color: rgb(0, 0, 0);
  text-decoration: none;
}

.nav-links li a:hover {
  text-decoration: underline;
}

/* Hamburger Button */
.menu-toggle {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
}

.menu-toggle span {
  display: block;
  width: 25px;
  height: 3px;
  background-color: rgb(0, 0, 0);
  transition: all 0.3s ease;
}

/* Hamburger animation when open */
.menu-toggle span.open:nth-child(1) {
  transform: rotate(45deg) translateY(8px);
}

.menu-toggle span.open:nth-child(2) {
  opacity: 0;
}

.menu-toggle span.open:nth-child(3) {
  transform: rotate(-45deg) translateY(-8px);
}


@media (max-width: 768px) {

  .menu-toggle {
    display: flex;
  }

  .nav-links {
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    background-color: #fbfbfb;
    flex-direction: column;
    display: none;
    padding: 1rem 0;
  }

  .nav-links.open {
    display: flex;
  }

  /* Make each menu item full width and align icon + text to left */
  .nav-links li {
    width: 100%;
  }

  .nav-links li a {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    color: rgb(0, 0, 0);
    text-decoration: none;
    justify-content: flex-start; /* align icon + text from left */
    white-space: normal; /* allow text wrapping */
  }

  .nav-links li a:hover {
    background-color: #136dd3;
  }

  /* Icon size */
  .icon {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
  }
}

</style>
